import theme from 'themes';

export const variableChipStyle = `color: ${theme.palette.purple[600]}; background-color: ${theme.palette.purple[50]}; 
border-radius: 4px; padding: 2px; padding-right: 4px; line-height: 1.5; border: 1px solid ${theme.palette.blueGrey[200]}; 
font-weight: 600; display: inline-block;`;
